import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PlanIndexComponent } from './crud-index/crud-index.component';
import { PlanCESComponent } from './crud-ces/crud-ces.component';

const routes: Routes = [
  {
    path: '',
    component: PlanIndexComponent,
  },
  {
    path: 'create',
    component: PlanCESComponent,
    data: [{ action: 'create' }],
  },
  {
    path: 'view/:id',
    component: PlanCESComponent,
    data: [{ action: 'view' }],
  },
  {
    path: 'edit/:id',
    component: PlanCESComponent,
    data: [{ action: 'edit' }],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PlansRoutingModule {}
